import { render } from "./EmployeeDutiesResponsibilities.vue?vue&type=template&id=5f3141c3"
import script from "./EmployeeDutiesResponsibilities.vue?vue&type=script&lang=js"
export * from "./EmployeeDutiesResponsibilities.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__